import KeywordForm from '../KeywordForm';
import DisplayForm from '../DisplayForm';
import ShopForm from '../ShopForm';
import RecommendForm from '../RecommendForm';
import OutboundKeywordForm from '../OutboundKeywordForm';
import { AdType } from 'core/rtbCampaign/RtbCampaign';
import { useCampaignStore } from 'store/campaignStore';
import { useProductStore } from 'store/productStore';
import { useEffect, useState, FC } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useCreateKeyword from 'containers/RtbCampaigns/RtbCampaignSelectAdType/Services/useCreateKeyword';
import useCreateDisplay from 'containers/RtbCampaigns/RtbCampaignSelectAdType/Services/useCreateDisplay';
import useCreateShop from 'containers/RtbCampaigns/RtbCampaignSelectAdType/Services/useCreateShop';
import useCreateRecommend from 'containers/RtbCampaigns/RtbCampaignSelectAdType/Services/useCreateRecommend';
import useCreateOutboundKeyword from 'containers/RtbCampaigns/RtbCampaignSelectAdType/Services/useCreateOutboundKeyword';

const CreatePage: FC = () => {
  const history = useHistory();
  const location = useLocation();

  const { adType } = useCampaignStore();
  const { resetProductStore } = useProductStore();
  const [campaign, setCampaign] = useState({});
  const { getDefaultCampaign: getKeywordDefaultCampaign } = useCreateKeyword();
  const { getDefaultCampaign: getDisplayDefaultCampaign } = useCreateDisplay();
  const { getDefaultCampaign: getShopDefaultCampaign } = useCreateShop();
  const { getDefaultCampaign: getRecommendDefaultCampaign } =
    useCreateRecommend();
  const { getDefaultCampaign: getOutboundKeywordDefaultCampaign } =
    useCreateOutboundKeyword();

  const fetchDefaultCampaign = async () => {
    try {
      let result;
      switch (adType) {
        case AdType.MAX_CVR_KEYWORD:
          result = getKeywordDefaultCampaign();
          break;
        case AdType.SHOP:
          result = getShopDefaultCampaign();
          break;
        case AdType.DISPLAY:
          result = getDisplayDefaultCampaign();
          break;
        case AdType.RECOMMEND:
          result = getRecommendDefaultCampaign();
          break;
        case AdType.OUTBOUND_KEYWORD:
          result = getOutboundKeywordDefaultCampaign();
          break;
        default:
          result = {};
      }
      setCampaign(result);
    } catch (error) {
      console.error(error);
    }
  };

  const formType = () => {
    switch (adType) {
      case AdType.MAX_CVR_KEYWORD:
        return <KeywordForm defaultForm={campaign} />;
      case AdType.SHOP:
        return <ShopForm defaultForm={campaign} />;
      case AdType.DISPLAY:
        return <DisplayForm defaultForm={campaign} />;
      case AdType.RECOMMEND:
        return <RecommendForm defaultForm={campaign} />;
      case AdType.OUTBOUND_KEYWORD:
        return <OutboundKeywordForm defaultForm={campaign} />;
      default:
        return '';
    }
  };

  useEffect(() => {
    if (adType !== AdType.UNKNOWN) {
      fetchDefaultCampaign();
    }
  }, [adType]);

  useEffect(() => {
    // 如果沒有選擇廣告活動類型，則導向選擇廣告活動類型頁面
    if (adType === AdType.UNKNOWN) {
      return history.push(
        location.pathname.replace('/create', '/select-adType'),
      );
    }
    return () => {
      resetProductStore();
    };
  }, []);

  return <>{Object.keys(campaign).length > 0 && formType()}</>;
};

export default CreatePage;
